import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { CkeditorConstants } from '../../src/utils';

const {
  class: { HIGHLIGHT_KEYWORD, WK_KEYWORD_REF },
  helperAttributes: { CITATION_COUNT, RESOURCE },
  htmlAttributes: { ID },
  localStorageItem: { BASE_HREF_FOR_KEYWORD, KEYWORD_ID_SELECT_FOR_CHEVRON }
} = CkeditorConstants;
export default class CitationRefNavCommand extends Plugin {

  constructor(editor) {
    super(editor);
    this.refresh();
  }

  execute({ value }) {
    const editor = this.editor;
    const rootElement = editor.editing.view.domRoots.get('main');
    let citationArray = value.referencedBy.map(id => rootElement.querySelector(`[id="${id}"]`));
    const baseHrefForKeyword = localStorage.getItem(BASE_HREF_FOR_KEYWORD);

    const keywordArray = Array.from(rootElement.querySelectorAll(`.${WK_KEYWORD_REF}`)).filter(item => item.getAttribute(RESOURCE) === `${baseHrefForKeyword}/${value.id}`);

    const traverseOn = keywordArray.length > 0 ? keywordArray : citationArray;

    const linkViewElements =  Array.from(traverseOn).map(domElement =>editor.editing.view.domConverter.mapDomToView(domElement));

    const currentModelPosition = value.selection;
    const currentViewPosition = editor.editing.mapper.toViewPosition(
      currentModelPosition
    );

    let lastLinkBeforeSelection, firstLinkAfterSelection;

    for (const linkViewElement of linkViewElements) {
      const linkViewPosition = editor.editing.view.createPositionBefore(
        linkViewElement
      );
      const compareResult = linkViewPosition.compareWith(currentViewPosition);
      if (keywordArray.length > 0) {
        const firstLinkAfterSelection = value.navDirection === 'right'
          ? linkViewElement
          : linkViewElements[linkViewElements.length - 1];

        if (compareResult === 'after') {
          logViewLink(firstLinkAfterSelection);
          break;
        } else if (compareResult === 'before') {
          const currentlySelectedKeywordRef = rootElement.querySelector(`.${HIGHLIGHT_KEYWORD}`);
          let currentlySelectedKeywordRefId;
          if (currentlySelectedKeywordRef) {
            currentlySelectedKeywordRefId = currentlySelectedKeywordRef.getAttribute(ID);
          }
          if (currentlySelectedKeywordRefId) {
            if (linkViewElement.getAttribute(ID) === currentlySelectedKeywordRefId) {
              if (value.navDirection === 'right' && linkViewElements.indexOf(linkViewElement) === 0) {
                logViewLink(linkViewElements[linkViewElements.indexOf(linkViewElement) + 1]);
                break;
              } else if (value.navDirection === 'left' && linkViewElements.indexOf(linkViewElement) !== 0) {
                logViewLink(linkViewElements[linkViewElements.indexOf(linkViewElement) - 1]);
                break;
              }
            }
          }
          if (value.navDirection === 'right') {
            logViewLink(linkViewElements[0]);
          }
        }
      } else {
        if (compareResult === 'before' && value.navDirection === 'left') {
          lastLinkBeforeSelection = linkViewElement;
          logViewLink(lastLinkBeforeSelection);
        }
        if (
          compareResult === 'after' &&
          value.navDirection === 'right' &&
          !firstLinkAfterSelection
        ) {
          firstLinkAfterSelection = linkViewElement;
          logViewLink(firstLinkAfterSelection);
        }
      }
    }

    if (citationArray.length > 0) {
      if (value.navDirection === 'right' && !firstLinkAfterSelection) {
        firstLinkAfterSelection = linkViewElements[0];
        logViewLink(firstLinkAfterSelection);
      }
      if (value.navDirection === 'left' && !lastLinkBeforeSelection) {
        lastLinkBeforeSelection = linkViewElements[linkViewElements.length - 1];
        logViewLink(lastLinkBeforeSelection);
      }
    }

    function logViewLink(viewElement) {
      const id = viewElement.getAttribute('id');
      if (!viewElement._classes.has(WK_KEYWORD_REF)) {
        const citationCount = viewElement.getAttribute(CITATION_COUNT);
        editor.execute('chevronnav', {
          value: { id, citationCount }
        });
      } else {
        localStorage.setItem(KEYWORD_ID_SELECT_FOR_CHEVRON, id);
      }
      editor.execute('setcursorposition', {
        id
      });
      document.querySelector(`.ck-editor__editable [id='${id}']`)
        .scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  refresh() {
  }
}